import type { IconProps } from '../types/IconProps.ts';
export const Image: IconProps = {
    name: 'Image',
    children: [
        `<rect width="18" height="18" x="3" y="3" rx="2" />`,
        `<path d="m6 21 8.13-8.13a2 2 0 0 1 2.04-.48L21 14" />`,
        `<circle cx="9" cy="9" r="2" />`,
    ]
};